import type { InjectionKey, Ref } from 'vue'
export interface CheckboxGroupContext {
  model: Ref<unknown[]>
  name: Ref<string>
  toggle: (value: unknown, checked: boolean) => void
}
export const checkboxGroupKey: InjectionKey<CheckboxGroupContext> = Symbol('checkbox-group')
